import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CarouselComponent } from 'ng-responsive-carousel';
import { Company } from 'src/app/core/models';
import { waitUntil } from '../../../core/utils';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { getTop10Companies } from '../../../core/store/company/company.selectors';
import { AppState } from '../../../core/store/app.state';
import * as CompanyActions from '../../../core/store/company/company.actions';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-company-ranks-carousel',
  templateUrl: './company-ranks-carousel.html',
})
export class CompanyRanksCarouselComponent implements OnInit, OnDestroy {
  @ViewChild(CarouselComponent, { static: false }) carousel: CarouselComponent;
  boards: Company[] | null;
  private readonly destroy$ = new Subject();
  constructor(
    private readonly router: Router,
    private store: Store<AppState>
  ) {}

  ngOnInit(): void {
    this.store.dispatch(CompanyActions.loadTopCompanies({}));
    this.store
      .pipe(select(getTop10Companies))
      .pipe(takeUntil(this.destroy$))
      .subscribe(companies => {
        this.boards = companies;
      });
    this.bindOnClickCarousel().then();
  }

  async bindOnClickCarousel() {
    // WAIT FOR THE CAROUSEL TO INITIALIZE
    await waitUntil(() => {
      return !!this.carousel?.touches;
    });

    this.carousel.touches.on('tap', (event: any) => {
      const nodes = Array.prototype.slice.call(
        this.carousel.cellsElement.children
      );
      const cellElement = event.srcElement.closest('.carousel-cell');
      const i = nodes.indexOf(cellElement);
      if (this.boards) this.viewCompanyDetails(this.boards[i]);
    });

    //TODO: ADD THIS FUNCTIONALITY?
    // this.carousel.touches.on('longtap', (event: any) => {
    //   console.log('longtap', event);
    // });
  }

  viewCompanyDetails(company: Company) {
    this.router.navigate(['/company', company.id, company.issuer_name]);
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
